import {ENCRYPTION_KEY} from '@/utils/constant';
/**
 * Encrypts a given text using XOR encryption and outputs the result as a hex string.
 *
 * @param {string} text - The plain text to encrypt.
 * @returns {string} The encrypted text in hexadecimal format.
 */
export function encrypt(text) {
  let encrypted = '';
  for (let i = 0; i < text.length; i++) {
    // XOR the character code of the text with the character code of the ENCRYPTION_KEY (cycling through the ENCRYPTION_KEY)
    const charCode = text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
    // Convert the result to a two-digit hex string and append it
    encrypted += charCode.toString(16).padStart(2, '0');
  }
  return encrypted;
}

/**
 * Decrypts a hex string back to the original text using XOR decryption.
 *
 * @param {string} hex - The encrypted text in hexadecimal format.
 * @returns {string} The decrypted plain text.
 */
export function decrypt(hex) {
  let decrypted = '';
  // Process two hex characters (one byte) at a time
  for (let i = 0; i < hex.length; i += 2) {
    // Convert the hex substring to a number
    const byte = parseInt(hex.substr(i, 2), 16);
    // XOR with the ENCRYPTION_KEY character (cycling through the ENCRYPTION_KEY) and convert back to a character
    const charCode = byte ^ ENCRYPTION_KEY.charCodeAt((i / 2) % ENCRYPTION_KEY.length);
    decrypted += String.fromCharCode(charCode);
  }
  return decrypted;
}
